import api from "@/app/api";
import Private from "@/app/components/Private";
import TablePage from "@/app/components/TablePage";
import { ApiContext } from "@/app/contexts/ApiContext";

export default function Users() {
  return (
    <ApiContext.Provider
      value={{
        listData: api.getUsers,
        getFieldOptions: api.getUserFieldOptions,
        getData: api.getUser,
        getFields: api.getUserFields,
        updateEntry: api.updateUser,
        createFieldOption: () =>
          new Promise((resolve) => resolve(undefined as any)),
      }}
    >
      <Private>
        <TablePage searchPlaceholder={"Search by user name..."} />
      </Private>
    </ApiContext.Provider>
  );
}
